import { Component, Input } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faCancel } from '@fortawesome/free-solid-svg-icons';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-failed-page',
  standalone: true,
  imports: [FontAwesomeModule,
    TranslateModule],
  templateUrl: './failed-page.component.html',
  styleUrl: './failed-page.component.css'
})
export class FailedPageComponent {


  constructor(
    public translate: TranslateService
  ) { }



  @Input() amount: string = '154.00';
  @Input() currency: string = 'OMR';
  @Input() referenceNumber: string = '000086752257';
  @Input() paymentTime: string = '25-02-2023, 13:22:16';
  @Input() paymentMethod: string = 'Bank Transfer';
  @Input() senderName: string = 'Ahmed Hassan';
  @Input() adminFee: string = '12.00';
  @Input() logoUrl: string = '../../../assets/img/logo.png';
  @Input() direction: 'rtl' | 'ltr' = 'rtl';

  faCancel = faCancel;

  labels = {
    refNumber: 'Ref Number',
    paymentTime: 'Payment Time',
    paymentMethod: 'Payment Method',
    senderName: 'Sender Name',
    adminFee: 'Admin Fee',
    downloadPDF: 'PDF تحميل',
  };

  downloadPDF() {
    // Implement PDF download logic here
    console.log('Downloading PDF...');
  }
}
